import { NavLink } from "react-router-dom";
import styled, { keyframes, css } from "styled-components";

const slideIn = keyframes`
  0% { opacity: 0; transform: translateY(10px); }
  100% { opacity: 1; transform: translateY(0); }
`;

export const slideInAnimation = ({
  time = "1s",
  type = "ease",
  duration = "0s",
} = {}) => css`
  animation: ${time} ${slideIn} ${type} ${duration};
`;

export const StyledCategory = styled(NavLink)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  text-decoration: none;
  flex-shrink: 0;
  transition: var(--tws-transition);
  width: ${(props) => (props.$isDesktop ? "72px" : "60px")};
  margin: ${(props) => (props.$isDesktop ? "0 4px 8px" : "0 10px")};
  padding: ${(props) => (props.$isDesktop ? "8px 4px 4px" : "0")};
  border-radius: ${(props) =>
    props.$isDesktop ? "var(--tws-radius-md)" : "0"};
  ${(props) =>
    props.$animate &&
    slideInAnimation({ time: "0.4s", type: "ease-out", duration: "0s" })};

  &[aria-current="page"] {
    font-weight: bold;
    & div {
      border-color: var(--tws-brown);
      background-color: var(--tws-cream);
    }
    & span {
      color: var(--tws-brown);
    }
    ${(props) =>
      props.$isDesktop &&
      css`
        background-color: var(--tws-muted);
      `}
  }

  &:hover {
    ${(props) =>
      props.$isDesktop &&
      css`
        background-color: var(--tws-muted);
      `}
    & div {
      border-color: var(--tws-brown);
    }
  }

  & div {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 2px solid var(--tws-border);
    background-color: var(--tws-white);
    transition: var(--tws-transition);
    width: 50px;
    height: 50px;
    flex-shrink: 0;
    ${(props) =>
      props.$isDesktop &&
      css`
        width: 44px;
        height: 44px;
      `}

    & img {
      max-width: 65%;
      max-height: 60%;
      object-fit: contain;
    }
  }

  & span {
    display: block;
    text-align: center;
    font-size: 0.65rem;
    color: var(--tws-text-muted);
    margin-top: 4px;
    line-height: 1.2;
    width: 100%;
    ${(props) =>
      props.$isDesktop &&
      css`
        font-size: 0.7rem;
      `}
  }
`;

export const StyledCategoriesGrid = styled.div`
  width: 100%;
  display: flex;
  justify-content: ${(props) => (props.$isDesktop ? "center" : "flex-start")};
  flex-wrap: ${(props) => (props.$isDesktop ? "wrap" : "nowrap")};
  overflow-x: ${(props) => (props.$isDesktop ? "visible" : "auto")};
  padding: ${(props) => (props.$isDesktop ? "8px 8px 2px" : "6px 4px")};
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  scroll-snap-type: ${(props) => (props.$isDesktop ? "none" : "x mandatory")};

  &::-webkit-scrollbar {
    display: none;
  }

  ${(props) =>
    !props.$isDesktop &&
    css`
      mask-image: linear-gradient(
        to right,
        transparent 0%,
        black 4%,
        black 96%,
        transparent 100%
      );
    `}
`;
